import { Radar, Zap } from "lucide-react";
import { isDetachedTask } from "../lib/tasks";
import { useFactory } from "../store";
import type { Task } from "../types";
import { ColorDot, ToneBadge } from "./status-badge";
import { Badge } from "./ui/badge";

/**
 * Where a work order is going: the lane intake picked, intake while the lane
 * is still open, or the detached section for a specialist run.
 * `quiet` hides the badge for the standard lane and intake, for dense lists.
 */
export function LaneBadge({ task, quiet, className }: { task: Task; quiet?: boolean; className?: string }) {
  const { layout } = useFactory();
  if (isDetachedTask(task, layout)) {
    return (
      <ToneBadge tone="violet" className={className}>
        <Radar /> Detached
      </ToneBadge>
    );
  }
  const lane = task.lane ? layout?.lanes[task.lane] : undefined;
  if (task.lane === "hotfix") {
    return (
      <ToneBadge tone="amber" className={className}>
        <Zap /> {quiet ? "Hotfix" : (lane?.name ?? "Hotfix")}
      </ToneBadge>
    );
  }
  if (quiet && (!task.lane || task.lane === "standard")) return null;
  if (lane) {
    return (
      <Badge variant="outline" className={className}>
        <ColorDot color={lane.color} className="size-2 ring-0" />
        {lane.name}
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className={className}>
      Intake
    </Badge>
  );
}
